import { render, staticRenderFns } from "./QuestionBankItem.vue?vue&type=template&id=e3fba81c"
import script from "./QuestionBankItem.vue?vue&type=script&lang=js"
export * from "./QuestionBankItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports